import { render, staticRenderFns } from "./FlatDetails.vue?vue&type=template&id=01b010f2&"
import script from "./FlatDetails.vue?vue&type=script&lang=ts&"
export * from "./FlatDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports